$(document).ready(function () {

    $('body').scrollspy({ target: '#navbar-services' });

    function getBaseURL() {
        var url = location.href;
        var baseURL = url.substring(0, url.indexOf('/', 14));

        if (baseURL.indexOf('http://localhost') != -1) {
            var url = location.href;
            var pathname = location.pathname;
            var index1 = url.indexOf(pathname);
            var index2 = url.indexOf("/", index1 + 1);
            var index3 = url.indexOf("/", index2 + 1);
            var baseLocalUrl = url.substr(0, index3);
            return baseLocalUrl + "/public/";
        }
        else {
            return baseURL + "/";
        }
    }

    function formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
    }

    $('#legalDiv').hide();

    $(window).scroll(function () {
        var sticky = $('#header-top'), scroll = $(window).scrollTop();

        if (scroll >= 3) {
            sticky.addClass('fixed');
        }
        else {
            sticky.removeClass('fixed');
        }
    });
    if ($("#contentTable").length) {
        $('#contentTable').DataTable(
            {
                "stateSave": false,
                "language": {
                    "lengthMenu": "_MENU_ / oldal",
                    "zeroRecords": "Nincs találat",
                    "info": "_PAGE_ / _PAGES_",
                    "infoEmpty": "Nincs adat",
                    "infoFiltered": "(_MAX_ rekordból szűrve)",
                    "sSearch": "Keresés",
                    "oPaginate": {
                        "sFirst": "Első",
                        "sPrevious": "Utolsó",
                        "sNext": "Következő",
                        "sLast": "Előző"
                    },
                },
                "pageLength": 50
            }
        );
    }
    if ($(".contentTable").length) {
        $('.contentTable').DataTable(
            {
                "stateSave": false,
                "language": {
                    "lengthMenu": "_MENU_ / oldal",
                    "zeroRecords": "Nincs találat",
                    "info": "_PAGE_ / _PAGES_",
                    "infoEmpty": "Nincs adat",
                    "infoFiltered": "(_MAX_ rekordból szűrve)",
                    "sSearch": "Keresés",
                    "oPaginate": {
                        "sFirst": "Első",
                        "sPrevious": "Utolsó",
                        "sNext": "Következő",
                        "sLast": "Előző"
                    },
                },
                "pageLength": 50,
            }
        );
    }

    if ($("#consultantTable").length) {
        $('#consultantTable').DataTable(
            {
                "stateSave": false,
                "paging": false,
                "ordering": false,
                "info": false,
                "searching": false,
                "language": {
                    "lengthMenu": "_MENU_ / oldal",
                    "zeroRecords": "Nincs találat",
                    "info": "_PAGE_ / _PAGES_",
                    "infoEmpty": "Nincs adat",
                    "infoFiltered": "(_MAX_ rekordból szűrve)",
                    "sSearch": "Keresés",
                    "oPaginate": {
                        "sFirst": "Első",
                        "sPrevious": "Utolsó",
                        "sNext": "Következő",
                        "sLast": "Előző"
                    }
                },
                "pageLength": 50,
                "columnDefs": [
                    {"width": "150px", "targets": 0},
                    {"width": "100px", "targets": 1},
                    {"width": "150px", "targets": 2},
                    {"width": "100px", "targets": 3},
                    {"width": "150px", "targets": 4}
                ]
            }
        );
    }


    //számlázási cím másolása postacímhez
    $('#addressRegCopy').on('click', function () {
        var zip = $('#billing_zip').val();
        var city = $('#billing_city').val();
        var address = $('#billing_address').val();

        $('#delivery_zip').val(zip);
        $('#delivery_city').val(city);
        $('#delivery_address').val(address);
    });

    //számlázási város kiegészítés
    $(document).on("keyup", "#billing_zip", function () {
        var zip = $('#billing_zip').val();
        $.post(getBaseURL() + "ajax/searchCity", {
            c: zip,
            _token: $('meta[name="_token"]').attr('content')
        }, function (data) {
            if (data != "") {
                $('#billing_city').val(data);
            }
        });
    });

    //számlázási város kiegészítés csoportos
    $(document).on("keyup", ".zip", function () {
        var id = $(this).attr('data-value');
        var zip = $('#billing_zip-' + id).val();

        if (zip.length == 4) {
            $.post(getBaseURL() + "ajax/searchCity", {
                c: zip,
                _token: $('meta[name="_token"]').attr('content')
            }, function (data) {
                if (data != "") {
                    $('#billing_city-' + id).val(data);
                }
            });
        }
    });

    //szállítási város kiegészítés
    $(document).on("keyup", "#delivery_zip", function () {
        var zip = $('#delivery_zip').val();
        $.post(getBaseURL() + "ajax/searchCity", {
            c: zip,
            _token: $('meta[name="_token"]').attr('content')
        }, function (data) {
            if (data != "") {
                $('#delivery_city').val(data);
            }
        });
    });

    //nyelv választás
    $('.setlang').on('click', function () {
        var lang = $(this).attr('data-value');
        $.post(getBaseURL() + "ajax/setLang", {lang: lang}, function (data) {
            if (data == "1") {
                setTimeout(function () {
                    window.location.reload(1);
                }, 1000);
            }
            else {
                alert('Ismeretlen hiba.');
            }
        });
    });

    //megye választás selector
    if ($("#county").length) {
        /*if ($.cookie('__Secure-actlang') == 'hu') {*/
        $('#county').select2({
            placeholder: 'Régió (Nem kötelező)'
        });
        /*  }
         else {
         $('#county').select2({
         placeholder: 'Region'
         });
         }*/
    }

    if ($(".fancybox").length) {
        //adatkezelési popup
        $('a.fancybox').fancybox();
    }

    if (document.getElementById('gdpr_statement')) {
        $('#gdpr_statement').load('//api.gdpreg.hu/v1/statement/2ee121a6-fea0-4a65-9334-ad14501d2128');
    }

    //webinarium slide
    if (document.getElementById('webinarium-box')) {
        $('#wbmsg').html('');
        $('#wbopen').click(function () {
            $('#webinarium-box').toggleClass("close");
            $('#webinarium-box').toggleClass("open");
            $('#nlslide-box').removeClass('nlopen');
            $('#nlslide-box').addClass('nlclose');
        });

        $('#wbclose').click(function () {
            $('#webinarium-box').removeClass('open');
            $('#webinarium-box').addClass('close');
        });

        /*$('#wbbtn').click(function () {
            if ($('#wbprivacy').prop('checked')) {
                $('#wbmsg').html('');
                var org = $('#wborg').val();
                var name = $('#wbname').val();
                var email = $('#wbemail').val();

                var priv = $('#wbprivacy').val();

                $.ajax({
                    headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
                    type: "post",
                    url: "ajax/webinariumSubscribe",
                    dataType: "html",
                    data: {
                        "_token": $('meta[name="csrf-token"]').attr('content'),
                        "org": org,
                        "name": name,
                        "email": email,
                        "priv": priv,
                    },
                    success: function (data) {
                        if (data == 1) {
                            $('#wborg').val('');
                            $('#wbname').val('');
                            $('#wbemail').val('');
                            $('#wbprivacy').prop('checked', false);
                            $('#wbmsg').html('<span style="color: #489001; font-weight: bold;">Sikeres feliratkozás! Köszönjük!</span>');
                        } else {
                            $('#wbmsg').html('<span style="color: red;">' + data + '</span>');
                        }
                    },
                    error: function (data) {
                        $('#wbmsg').html('<span style="color: red;">' + data + '</span>');
                    }
                });
            } else {
                $('#wbmsg').html('<span style="color: red;">Nem fogadta el az adatkezelési tájékoztatót!</span>');
            }
        });*/
    }


// hírlevél slide

    if (document.getElementById('nlslide-box')) {
        $('#wbmsg').html('');
        $('#nlopen').click(function () {
            $('#nlslide-box').toggleClass("nlclose");
            $('#nlslide-box').toggleClass("nlopen");
            $('#webinarium-box').removeClass('open');
            $('#webinarium-box').addClass('close');
        });

        $('#nlclose').click(function () {
            $('#nlslide-box').removeClass('nlopen');
            $('#nlslide-box').addClass('nlclose');
        });

        /*$('#nlbtn').click(function () {
            if ($('#wbprivacy').prop('checked')) {
                $('#wbmsg').html('');
                var org = $('#wborg').val();
                var name = $('#wbname').val();
                var email = $('#wbemail').val();
                $.post(getBaseURL() + "ajax/webinariumSubscribe", {
                    name: name,
                    email: email
                }, function (data) {
                    if (data == "1") {
                        $('#wborg').val('');
                        $('#wbname').val('');
                        $('#wbemail').val('');
                        $('#wbprivacy').prop('checked', false);
                        $('#wbmsg').html('<span style="color: #489001; font-weight: bold;">Sikeres felíratkozást! Köszönjük!</span>');
                    }
                    else {
                        $('#wbmsg').html('<span style="color: red;">' + data + '</span>');
                    }
                });
            }
            else {
                $('#wbmsg').html('<span style="color: red;">Nem fogadta le az adatkezelési tájékoztatót!</span>');
            }
        });*/
    }

//hírlevél felíratkozás
    $('#nlbtn').on('click', function () {
        if ($('#nlprivacy').prop("checked")) {
            var org = $('#nlorg').val();
            var name = $('#nlname').val();
            var email = $('#nlemail').val();

            var priv = $('#nlprivacy').val();

            $.ajax({
                headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
                type: "post",
                url: "ajax/newsletterSubscribe",
                dataType: "html",
                data: {
                    "_token": $('meta[name="csrf-token"]').attr('content'),
                    "org": org,
                    "name": name,
                    "email": email,
                    "privacy": priv
                },
                success: function (data) {
                    if (data == 1) {
                        $('#nlorg').val('');
                        $('#nlname').val('');
                        $('#nlemail').val('');
                        $('#nlprivacy').prop('checked', false);//.checkboxradio('refresh');
                        $('#nlmsg').html('<span style="color: #489001; font-weight: bold;">Sikeres felíratkozást! Köszönjük!</span>');
                    } else {
                        $('#nlmsg').html('<span style="color: red;">' + data + '</span>');
                    }
                },
                error: function (data) {
                    $('#nlmsg').html('<span style="color: red;">' + data + '</span>');
                }
            });
        }
        else {
            $('#nlmsg').html('<span style="color: red;">Nem fogadta el az Adatkezelési tájékoztatót!</span>');

        }
    });

    /*$('.card').css("min-height", $(window).height() - ($("#footer").height() + 245) + "px");*/

//csoportos megrendelés, csomag hozzáadás
    $('#csomagCsopAddBtn').on('click', function () {
        var delayInMilliseconds = 500; //wait 0,5 second

        setTimeout(function () {
            $.when(cartPost()).done(function (a1) {
                var errors = document.getElementsByClassName('error-text');
                var errMsg = false;

                for (var i = 0; i < errors.length; i++) {
                    if (errors[i].innerText != '') {
                        errMsg = true;
                        break;
                    }
                }

                if (!errMsg) {
                    $.ajax({
                        //headers: {'X-CSRF-Token': $('meta[name=_token]').attr('content')},
                        type: "post",
                        url: "/ajax/groupPackageAdd",
                        dataType: "html",
                        cache: false,
                        data: {
                            "existing": document.querySelector('#gsub').checked,
                            "_token": $('meta[name="_token"]').attr('content'),
                            "add": '1',
                        },
                        success: function (data, text) {
                            if (data.search('<') >= 0) {
                                $('#orgPackage').html('');
                                $('#orgPackage').append(data);

                                //document.getElementById('csomagCsopAddBtn').disabled = false;
                            } else {
                                console.log("Hiba lépett fel a kérés feldolgozása során!");
                                //document.getElementById('csomagCsopAddBtn').disabled = true;
                                //console.log(data);
                            }
                        },
                        error: function (XMLHttpRequest, textStatus, errorThrown) {
                            console.log("Hiba lépett fel a kérés során!");
                        }
                    });
                }
            });
        }, delayInMilliseconds);
    });

    function cartPost() {
        return $.ajax({
            //headers: {'X-CSRF-Token': $('meta[name=_token]').attr('content')},
            type: "post",
            url: "/ajax/getCartCount",
            dataType: "html",
            data: {
                "_token": $('meta[name="_token"]').attr('content'),
            },
            success: function (data, text) {
                $.when($.calcPackages(data, 'name')).done(function () {
                });
            },
        });
    }

//csoportos megrendelés, csomag hozzáadás
    $('#AjCsopAddBtn').on('click', function () {
        var aj = parseInt($('#orgnum').val());
        $.post(getBaseURL() + "ajax/AjCsopAdd", {_token: $('meta[name="_token"]').attr('content'), add: aj},
            function (data) {
                if (data.search('<') >= 0) {
                    $('#AjCsop').append(data);
                    $('#orgnum').val(aj + parseInt(1));
                    $('#bidinf').css('display', 'block');
                    //location.reload();
                }
                else {
                    alert(data);
                }
            }
        );
    });

//csoportos megrendelés, csomag törlés
    $(document).on('click', '.AjCsopDelBtn', function () {
        var id = $(this).attr('data-value');
        $.post(getBaseURL() + "ajax/AjCsopDel", {del: id}, function (data) {
            if (data == 1) {
                //location.reload();
                $('#bidForm').submit();
            }
            else {
                alert(data);
            }
        });
        alert(id);
    });

//csoportos megrendelés
    $('#csomagCsopRenBtn').on('click', function () {
        if ($("#csomagCsopPrivacy").prop("checked") == true) {
            if ($("#csomagCsopTerms").prop("checked") == true) {
                /*$.post(getBaseURL() + "ajax/groupPackageOrder", {order: '1'}, function (data) {
                 if (data == 1) {

                 $(location).attr('href', getBaseURL() + '/sikeres-regisztracio');

                 }
                 else {
                 alert(data);
                 }
                 });*/
                $('#pckFrm').submit();
            }
            else {
                alert('Nem fogadta el az Általános szerződési feltételeket.');
            }
        }
        else {
            alert('Nem fogadta el az Adatkezelési Tájékoztatót.');
        }
    });

    $('#groupDelBtn').on('click', function () {
        if (!confirm('Biztosan törölni szeretné az adatokat?')) return false;
        $.get(getBaseURL() + "ajax/groupdel", {}, function (data) {
            if (data == 1) {
                window.location = getBaseURL() + 'csomagok';
            }
        });
    });

//csoportos megrendelés főszervezet adószám kiemelés
    $('#gsub').on('click', function () {
            if ($('#gsub').prop('checked') == true) {
                $('.gtax').css('border', 'solid 2px #232332');

                $('#name-0').prop('disabled', 'disabled');
                $('#email-0').prop('disabled', 'disabled');
                $('#financial_email-0').prop('disabled', 'disabled');
                if ($('#tax_number-0').val().length >= 8) {
                    $('#tax_number-0').prop('disabled', 'disabled');
                }
                $('#contact_name-0').prop('disabled', 'disabled');
                $('#contact_phone-0').prop('disabled', 'disabled');
                $('#type-0').prop('disabled', 'disabled');
                $('#billing_country-0').prop('disabled', 'disabled');
                $('#billing_zip-0').prop('disabled', 'disabled');
                $('#billing_city-0').prop('disabled', 'disabled');
                $('#billing_district-0').prop('disabled', 'disabled');
                $('#billing_street_name-0').prop('disabled', 'disabled');
                $('#billing_street_type-0').prop('disabled', 'disabled');
                $('#billing_house_nr-0').prop('disabled', 'disabled');
                $('#billing_block-0').prop('disabled', 'disabled');
                $('#billing_entrance-0').prop('disabled', 'disabled');
                $('#billing_floor-0').prop('disabled', 'disabled');
                $('#billing_door-0').prop('disabled', 'disabled');
                $('#package-0').prop('disabled', 'disabled');
                $('#mentor-0').prop('disabled', 'disabled');
                $('#asz').prop('disabled', 'disabled');
                $('#szt').prop('disabled', 'disabled');
                $('#at').prop('disabled', 'disabled');
            }
            else if ($('#gsub').prop('checked') == false) {
                var box = confirm("Ha ezt választod minden szervezet törlődik, biztosan folytatod?");

                if (box == true) {
                    $.get(getBaseURL() + "ajax/groupdel", {}, function (data) {
                        if (data == 1) {
                            window.location = getBaseURL() + 'csomagok';
                        }
                    });
                    return true
                } else {
                    document.getElementById("gsub").checked = true;
                }
            }
        }
    );

//csoportos megrendelés főszervezet regisztráció ellenőrzés
    $('.gtax').on('keyup', function () {
        if ($('#gsub').prop('checked') == true) {
            var gtax = $(this).val();

            if (($.isNumeric(gtax) && gtax.length >= 8 && gtax.length <= 13) || (!$.isNumeric(gtax) && gtax.length >= 9)) {
                post_data = {
                    "_token": $('meta[name="_token"]').attr('content'),
                    "gtax": gtax
                };

                $.ajax({
                    type: 'POST',
                    url: 'ajax/gtaxcheck',
                    data: post_data,
                    success: function (data) {
                        $('#tmsg').html('');
                        alert('Az adószám ellenőrzés sikeres, az oldal frissítésre kerül.');
                        $(this).val('');
                        window.location = getBaseURL() + 'csomagok';
                    },
                    error: function () {
                        //$('#tmsg').html('<span style="color: #9c3328; font-weight: bold;">' + data + '</span>');
                    }
                })
                ;
                //$('#tmsg').html('<span style="color: #9c3328; font-weight: bold;">' + data + '</span>');

                /*$.get(getBaseURL() + "ajax/gtaxcheck", {gtax: gtax}, function (data) {
                    if (data == 1) {
                        $('#tmsg').html('');
                        alert('Az adószám ellenőrzés sikeres, az oldal frissítésre kerül.');
                        $(this).val('');
                        window.location = getBaseURL() + 'csomagok';
                    }
                    else {
                        $('#tmsg').html('<span style="color: #9c3328; font-weight: bold;">' + data + '</span>');
                    }
                });*/
            }
        }

    });

    $.removeStreetType = function ($i, $name) {
        var x = document.getElementsByClassName($i + '.' + $name + '_err');

        if (x != "") {
            x[0].classList.remove('p-1');
            x[0].innerText = "";
        }
    }

//csoportrendelés táblázat lehívás
    $.calcPackages = function ($i, $actual_field_name) {
        var n = $i;

        var token = $('meta[name="_token"]').attr('content');
        var name = $('#name-' + n).val();
        var email = $('#email-' + n).val();
        var financial_email = $('#financial_email-' + n).val();
        var tax_number = $('#tax_number-' + n).val();
        var contact_name = $('#contact_name-' + n).val();
        var contact_phone = $('#contact_phone-' + n).val();
        var type = $('#type-' + n).val();
        var billing_country = $('#billing_country-' + n).val();
        var billing_zip = $('#billing_zip-' + n).val();
        var billing_city = $('#billing_city-' + n).val();
        var billing_district = $('#billing_district-' + n).val();
        var billing_street_name = $('#billing_street_name-' + n).val();
        var billing_street_type = $('#billing_street_type-' + n).val();
        var billing_house_nr = $('#billing_house_nr-' + n).val();
        var billing_block = $('#billing_block-' + n).val();
        var billing_entrance = $('#billing_entrance-' + n).val();
        var billing_floor = $('#billing_floor-' + n).val();
        var billing_door = $('#billing_door-' + n).val();
        var opackage = $('#package-' + n).val();
        var mentor = $('#mentor-' + n).val();
        var asz = 0;
        var szt = 0;
        var at = 0;
        var gsub = 0;

        var registrations = {"name": name, "package": opackage, "price": 100,}

        if ($('#asz').prop('checked') == true) {
            asz = 1;
        }
        if ($('#szt').prop('checked') == true) {
            szt = 1;
        }
        if ($('#at').prop('checked') == true) {
            at = 1;
        }

        if ($('#gsub').prop('checked') == true) {
            gsub = 1;
        }

        $.post(getBaseURL() + "ajax/groupPackageAddToCart", {
            _token: token,
            add: n,
            name: name,
            type: type,
            package: opackage,
            email: email,
            financial_email: financial_email,
            tax_number: tax_number,
            contact_name: contact_name,
            contact_phone: contact_phone,
            billing_country: billing_country,
            billing_zip: billing_zip,
            billing_city: billing_city,
            billing_district: billing_district,
            billing_street_name: billing_street_name,
            billing_street_type: billing_street_type,
            billing_house_nr: billing_house_nr,
            billing_block: billing_block,
            billing_entrance: billing_entrance,
            billing_floor: billing_floor,
            billing_door: billing_door,
            mentor: mentor,
            asz: asz,
            szt: szt,
            at: at,
        }, function (data) {
            if (data == 1) {
                x = document.getElementsByClassName("error-text");
                for (var i = 0; i < x.length; i++) {
                    if ($actual_field_name.localeCompare('tax_number') == 0) {
                        if (x[i].classList.contains("p-1") && x[i].textContent.includes("Egy adószám csak egyszer szerepelhet.")) {
                            x[i].innerText = "";
                            x[i].classList.remove("p-1");
                        }
                    }
                    if (x[i].classList.contains(n + '.' + $actual_field_name + '_err')) {
                        x[i].innerText = "";
                        x[i].classList.remove("p-1");

                        if ($actual_field_name.localeCompare('billing_zip') == 0) {
                            if (x[i + 1].classList.contains(n + ".billing_city_err") && x[i + 1].classList.contains("p-1")) {
                                x[i + 1].innerText = "";
                                x[i + 1].classList.remove("p-1");
                            } else if (x[i + 2].classList.contains(n + ".billing_city_err") && x[i + 2].classList.contains("p-1")) {
                                x[i + 2].innerText = "";
                                x[i + 2].classList.remove("p-1");
                            } else if (x[i + 3].classList.contains(n + ".billing_city_err") && x[i + 2].classList.contains("p-1")) {
                                x[i + 3].innerText = "";
                                x[i + 3].classList.remove("p-1");
                            }
                        }
                    }
                }

                if ($actual_field_name.localeCompare('name') == 0 || $actual_field_name.localeCompare('type') == 0 ||
                    $actual_field_name.localeCompare('package') == 0 || $actual_field_name.localeCompare('asz') == 0 ||
                    $actual_field_name.localeCompare('szt') == 0 || $actual_field_name.localeCompare('at') == 0) {
                    $.post(getBaseURL() + "ajax/groupCart", {
                        _token: token,
                        add: 1,
                        type: type,
                        tax_number: tax_number,
                        asz: asz,
                        szt: szt,
                        at: at,
                        gsub: gsub,
                        registrations: registrations
                    }, function (data) {
                        $('#orgPackCal').html('');
                        $('#orgPackCal').html(data);
                    });
                }
                //document.getElementById('csomagCsopAddBtn').disabled = false;
            } else {
                x = document.getElementsByClassName("error-text");
                for (var i = 0; i < x.length; i++) {
                    x[i].innerText = "";
                    x[i].classList.remove("p-1");
                }

                $.each(data, function (key, value) {
                    //append error message
                    $('[class*="' + key + '_err"]').text(value);
                    $('[class*="' + key + '_err"]').addClass("p-1");
                });
            }
        });
    }

    $.calcPackPie = function () {
        var opackage = $('#selpackage').val();
        var type = $('#regOrgType').val();

        if (opackage == 0) {
            alert('Válasszon csomagot');
        }

        else {
            if (type == 'EUSZ' || type == 'OKT') {
                $('.percent').html('<b style="color: red;">-10% kedvezmény</b>');
            }
            else if (type == 'EUSZ_HO' || type == 'ONK') {
                $('.percent').html('<b style="color: red;">-51% egyedi kedvezmény<br>-10% általános kedvezmény</br>');
            }
            else {
                $('.percent').html('');
            }
        }
    }

    $(function () {
        $('.tooltip').tooltip({
            content: function () {
                return $(this).prop('title');
            },
            show: null,
            close: function (event, ui) {
                ui.tooltip.hover(
                    function () {
                        $(this).stop(true).fadeTo(400, 1);
                    },

                    function () {
                        $(this).fadeOut("400", function () {
                            $(this).remove();
                        })
                    });
            }
        });
    });

    $(function () {
        $("#dialog").dialog({autoOpen: false});
    });

    $("#labtn").on("click", function () {
        $("#dialog").dialog("open");
    });

//jogi tanácsadás érdeklődés form

    $('#laBtn').on('click', function () {
        var emt = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        var tt = /^[0-9\ \-\(\)\+]+$/;
        var name = $('#la_name').val();
        var contact_name = $('#la_contact_name').val();
        var contact_phone = $('#la_contact_phone').val();
        var contact_email = $('#la_contact_email').val();
        var zip = $('#la_zip').val();
        var city = $('#la_city').val();
        var address = $('#la_address').val();

        var la1 = 0;
        var la2 = 0;
        var la3 = 0;
        var la4 = 0;

        if (name == '') {
            alert('Adja meg a szervezet nevét.');
        }
        else if (contact_name == '') {
            alert('Adja meg a kapcsolattartó nevét.');
        }
        else if (contact_phone == '') {
            alert('Adja meg a kapcsolattartó telefonszámát.');
        }
        else if (contact_email == '') {
            alert('Adja meg a kapcsolattartó email címét.');
        }
        else if (!emt.test(contact_email)) {
            alert('Nem megfelelő email formátum.');
        }
        else if (!tt.test(contact_phone)) {
            alert('Nem megfelelő telefonszám formátum.');
        }
        else if (zip == '') {
            alert('Adja meg az irányítószámot.');
        }
        else if (!$.isNumeric(zip)) {
            alert('Hibás irányítószám.');
        }
        else if (city == '') {
            alert('Adja meg a települést.');
        }
        else if (address == '') {
            alert('Adja meg a címet.');
        }
        else if ($('#la-ok').prop('checked') == false) {
            alert('Nem járult hozzá az adatok elküldéséhez.');
        }
        else {
            if ($('#la-1').prop('checked') == true) {
                la1 = 1;
            }

            if ($('#la-2').prop('checked') == true) {
                la2 = 1;
            }
            if ($('#la-3').prop('checked') == true) {
                la3 = 1;
            }
            if ($('#la-4').prop('checked') == true) {
                la4 = 1;
            }

            $.post(getBaseURL() + "ajax/lacontact", {
                name: name,
                contact_name: contact_name,
                contact_email: contact_email,
                contact_phone: contact_phone,
                zip: zip,
                city: city,
                address: address,
                la1: la1,
                la2: la2,
                la3: la3
            }, function (data) {
                if (data == 1) {
                    $('#la_name').val('');
                    $('#la_contact_name').val('');
                    $('#la_contact_phone').val('');
                    $('#la_contact_email').val('');
                    $('#la_zip').val('');
                    $('#la_city').val('');
                    $('#la_address').val('');
                    $('#la-1').prop('checked', false);
                    $('#la-2').prop('checked', false);
                    $('#la-3').prop('checked', false);
                    $('#la-ok').prop('checked', false);
                    alert('Elküldtük érdeklődését.');
                }
                else {
                    alert(data);
                }
            });
        }
    });


//csoportos regisztráció tag törlése
    $('body').on('click', '.delge', function () {
        if (!confirm('Biztosan törölni szeretné a csoporttagot?')) return false;
        var id = $(this).attr('data-value');
        var token = $('meta[name="_token"]').attr('content');
        var url = window.location.href;
        $.post(getBaseURL() + "ajax/dge", {id: id, _token: token}, function (data) {
            if (data == 1) {
                $(location).attr("href", url.replace("#lgda", ""));
            }
            else {
                alert('Ismeretlen hiba.');
            }
        });
    });

//konferencia jelentkezés
    if (document.getElementById('tsz')) {
        $('#tsz').keyup(function () {
            var tsz = $(this).val();

            if (tsz.length === 8) {
                $.post(getBaseURL() + "ajax/tszc", {tsz: tsz}, function (data) {

                    if (data != 0) {
                        $('#tszmsg').html('<div class="success"><b>Sikeres ellenőrzés!</b><br><small>Az oldal frissítésre kerül.</small></div>');
                        setTimeout(function () {
                            window.location.reload(1);
                        }, 3000);
                    }
                    else {
                        $.post(getBaseURL() + "ajax/tszr", {tsz: tsz}, function (data) {
                            if (data != 0) {
                                $('#tszmsg').html('<div class="success"><b>Sikeres ellenőrzés!</b><br><small>Az oldal frissítésre kerül.</small></div>');
                                setTimeout(function () {
                                    window.location.reload(1);
                                }, 3000);
                            }
                            else {
                                alert('Az adószám nem található rendszerünkben. Kérjük adja meg a szervezet adatait.');
                            }
                        });
                    }
                });
            }
        });
    }

    $.confchk = function () {
        var tszh = $('#tszh').val();
        var tszn = $('#szn').val();
        var confv = $('input[name=conf]:checked').attr('data-content');

        var rv1 = $('#rv1').val();
        var rv2 = $('#rv2').val();
        var rv3 = $('#rv3').val();
        var price = 6000;
        var all = 0;
        var msg = '';
        msg += '<table cellpadding="2"  cellspacing="0" style="width: 50%;" align="center"><thead><tr><th style="border-top: solid 1px #232332; border-bottom: solid 1px #232332; border-left: solid 1px #232332;">Résztvevő';
        if (confv != '' && confv != undefined) {
            msg += ' | ' + confv;
        }
        msg += '</th><th style="border: solid 1px #232332;">Résztvételi díj</th></tr><tbody>';

        if (rv1 != '') {
            msg += '<tr><td style="text-align: left; border-bottom: solid 1px #232332; border-left: solid 1px #232332;">' + rv1 + '</td><td style="text-align: right; border-bottom: solid 1px #232332; border-left: solid 1px #232332; border-right: solid 1px #232332;">';
            if (tszh != 0 && tszn != 1) {

                msg += '<span style="color:#60A40F; ">Ingyenes</span>';
            }
            else {
                msg += formatNumber(price) + ' Ft + Áfa';
                all = all + price;
            }
            msg += '</td></tr>';
        }
        if (rv2 != '') {
            msg += '<tr><td style="text-align: left; border-bottom: solid 1px #232332; border-left: solid 1px #232332;">' + rv2 + '</td><td style="text-align: right; border-bottom: solid 1px #232332; border-left: solid 1px #232332; border-right: solid 1px #232332;">' + formatNumber(price) + ' Ft + Áfa</td></tr>';
            all = all + price;
        }
        if (rv3 != '') {
            msg += '<tr><td style="text-align: left; border-bottom: solid 1px #232332; border-left: solid 1px #232332;">' + rv3 + '</td><td style="text-align: right; border-bottom: solid 1px #232332; border-left: solid 1px #232332; border-right: solid 1px #232332;">' + formatNumber(price) + ' Ft + Áfa</td></tr>';
            all = all + price;
        }

        msg += '<tr><td style="text-align: left; border-bottom: solid 1px #232332; border-left: solid 1px #232332;">Összesen:</td><td style="text-align: right; border-bottom: solid 1px #232332; border-left: solid 1px #232332; border-right: solid 1px #232332;">' + formatNumber(all) + ' Ft + Áfa</td></tr>';
        msg += '</tbody></table>';
        if (all > 0) {
            msg += "<p>A kitöltött adatok alapján díjbekérőt küldünk a megadott e-mail címre. Átutalás esetén kérjük hivatkozzon a díjbekérő számára. A jelentkezés a pénzügyi teljesítést követően küldött számlával válik véglegessé (a férőhelyek korlátozottak).</p>"
        }

        if (rv1 != '' || rv2 != '' || rv3 != '') {
            $('#confchkmsg').html(msg);
        }
    }

//konferencia form enter tiltás
    $('#conference').on('keyup keypress', function (e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            e.preventDefault();
            return false;
        }
    });

//konferencia szervezet létszám ellenőrzés, online felíratkozás
    if (document.getElementById('cbtn')) {
        var cp = $('#cp').val();
        var msg = '&nbsp;&nbsp;<i class="fas fa-long-arrow-alt-down"></i>&nbsp;Válassza ezt az opciót a regisztrációhoz.<br/>';

        if (cp >= 3) {
            $('#cbtn').prop("disabled", true);
            $('#ocmsg').html(msg);
            $('#oc').click(function () {
                $('#cbtn').prop("disabled", !$("#oc").prop("checked"));
                if ($('#cbtn').is(':disabled')) {
                    $('#ocmsg').html(msg);
                }
                if ($('#cbtn').is(':enabled')) {
                    $('#ocmsg').html('');
                }
            })
        }
    }

    $('#emailSendBtn').click(function () {
        var name = $('#emailName').val();
        var email = $('#emailAddress').val();
        var url = $('#emailBidUrl').val();
        var pattern = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

        $('#emailSendMsg').html('');
        $('#emailSendCheck-1').removeClass('is-invalid');
        $('#emailAddress').removeClass('is-invalid');
        $('#emailName').removeClass('is-invalid');

        if ($('#emailSendCheck-1').is(':checked')) {

            var newsletter = 0;

            if ($('#emailSendCheck-2').is(':checked')) {
                newsletter = $('#emailSendCheck-2').val();
                if (name == '') {
                    $('#name').addClass('is-invalid');
                    $('#emailSendMsg').append('<div class="alert alert-danger text-center">Kérjük adja meg nevét a feliratkozáshoz.</div>');
                }
            }

            //$('#emailSendMsg').html('');

            if (email == ''/* || name == ''*/) {
                /*if(name == '') {
                    $('#emailName').addClass('is-invalid');
                    $('#emailSendMsg').append('<div class="alert alert-danger text-center">Kérjük adja meg a nevét.</div>');
                }
                if(email == '') {*/
                $('#emailAddress').addClass('is-invalid');
                $('#emailSendMsg').append('<div class="alert alert-danger text-center">Kérjük adja meg az e-mail címet.</div>');
                /*}*/
            }
            else {
                if (!pattern.test(email)) {
                    $('#emailAddress').addClass('is-invalid');
                    $('#emailSendMsg').append('<div class="alert alert-danger text-center">Az email cím nem megfelelő.</div>');
                }
                else {

                    $('#emailSendMsg').html('').append('<div class="d-flex justify-content-center"><div class="spinner-border m-2" role="status"><span class="sr-only">Loading...</span></div></div>');

                    $.post(getBaseURL() + "ajax/bidEmailSend", {
                        _token: $('meta[name="_token"]').attr('content'),
                        name: name,
                        email: email,
                        url: url,
                        checktype: $('#emailSendCheck-1').val(),
                        newsletter: newsletter,
                    }, function (data) {
                        $('#emailSendMsg').html('<div class="alert alert-success text-center">Az árajánlatot elküldtük a következő email címre: ' + email + '</div>');
                        $('#emailAddress').val('');
                        $('#emailName').val('');
                        $('#emailSendCheck-1').prop('checked', false);
                        $('#emailSendCheck-2').prop('checked', false);
                    })
                        .fail(function (response) {
                            $('#emailSendMsg').append('<div class="alert alert-danger text-center">Hiba lépett fel a küldés során!</div>');
                        });
                }
            }
        }
        else {
            $('#emailSendCheck-1').addClass('is-invalid');
            $('#emailSendMsg').append('<div class="alert alert-danger text-center">Nem fogadta el az Adatkezelési tájékoztatót!</div>');
        }
    });

    $('#emailSendClose').click(function () {
        $('#emailSendMsg').html('');
        $('#emailAddress').val('');
        $('#emailSendCheck-1').prop('checked', false);
        $('#emailSendCheck-2').prop('checked', false);
    });

    $('#emailSendCloseX').click(function () {
        $('#emailSendMsg').html('');
        $('#emailAddress').val('');
        $('#emailSendCheck-1').prop('checked', false);
        $('#emailSendCheck-2').prop('checked', false);
    });

// collapse plus/minus
    $(".collapse.show").each(function () {
        $(this).prev(".col-header").find(".fa").addClass("fa-chevron-up").removeClass("fa-chevron-down");
    });

    $(".collapse").on('show.bs.collapse', function () {
        $(this).prev(".col-header").find(".fa").removeClass("fa-chevron-down").addClass("fa-chevron-up");
    }).on('hide.bs.collapse', function () {
        $(this).prev(".col-header").find(".fa").removeClass("fa-chevron-up").addClass("fa-chevron-down");
    });

    $.printPageButton = function ($divName) {
        var mywindow = window.open('', 'PRINT', 'height=400,width=600');

        mywindow.document.write('<html><head><title>' + "GDPReg - Általános szerződési feltételek" + '</title>');
        mywindow.document.write('</head><body >');
        mywindow.document.write(document.getElementById($divName).innerHTML);
        mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        mywindow.close();
    }

    /*var count_particles, stats, update;
    stats = new Stats;
    stats.setMode(0);
    stats.domElement.style.position = 'absolute';
    stats.domElement.style.left = '0px';
    stats.domElement.style.top = '0px';
    document.body.appendChild(stats.domElement);
    count_particles = document.querySelector('.js-count-particles');
    update = function () {
        stats.begin();
        stats.end();
        if (window.pJSDom[0].pJS.particles && window.pJSDom[0].pJS.particles.array) {
            count_particles.innerText = window.pJSDom[0].pJS.particles.array.length;
        }
        requestAnimationFrame(update);
    };
    requestAnimationFrame(update);
    ;
*/
});

window.convertToStringUppercase = function (id) {
    var str = document.getElementById(id).value.trim();
    var token = $('meta[name="_token"]').attr('content');
    if (str.length > 0) {
        str = str.toLowerCase().split(' ');
        for (var i = 0; i < str.length; i++) {
            if (str[i].length > 0) {
                if (str[i][0] != '"') {
                    str[i] = str[i].split('');
                    str[i][0] = str[i][0].toUpperCase();
                    str[i] = str[i].join('');
                } else {
                    str[i] = str[i].toUpperCase();
                }
            }
        }
        document.getElementById(id).value = str.join(' ').replace(/-(.)/g, function (m, c) {
            return '-' + c.toUpperCase();
        });
    }
};
